import { render, staticRenderFns } from "./companyRegi.vue?vue&type=template&id=041776e7&scoped=true&"
import script from "./companyRegi.vue?vue&type=script&lang=js&"
export * from "./companyRegi.vue?vue&type=script&lang=js&"
import style0 from "./companyRegi.vue?vue&type=style&index=0&id=041776e7&prod&lang=less&scoped=true&"
import style1 from "./companyRegi.vue?vue&type=style&index=1&id=041776e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041776e7",
  null
  
)

export default component.exports